const baseURL = String(process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

function normalizePathId(id) {
    if (!id) return "";
    if (typeof id === "object") {
        return String(id._id || id.id || id.branchId || "").trim();
    }
    return String(id).trim();
}

export function getApiBaseURL() {
    return baseURL;
}

export function getLocalServerURL() {
    return baseURL.replace(/\/api\/v1\/?$/, "");
}

export function getAllBranchesURL() {
    return baseURL + "/branches/";
}

export function getAllComplaintsURL() {
    return baseURL + "/admin/complaints";
}

export function getAllContactUsURL() {
    return baseURL + "/contact-us";
}

export function getAllLoginLogsURL() {
    return baseURL + "/login-logs";
}

export function getUpdateComplaintURL() {
    return baseURL + "/complaints/updateComplaint";
}

export function getDeleteComplaintURL(id) {
    return baseURL + "/complaints/" + id;
}

export function getLicenseDetailURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/license-detail";
}

export function getLicenseValidityURL(branchId) {
    return getLicenseDetailURL(branchId);
}

export function getLicenseDetailByBranchURL(branchId) {
    return getLicenseDetailURL(branchId);
}

export function getBranchURL(id) {
    return baseURL + "/branches/" + id;
}

export function saveBranchObjectsURL(branchId) {
    return baseURL + "/branches/" + encodeURIComponent(normalizePathId(branchId)) + "/branch-objects";
}

export function getDesktopCredentialURL(branchId) {
    return baseURL + "/branches/" + encodeURIComponent(normalizePathId(branchId)) + "/desktop-credential";
}

export function createDesktopCredentialURL(branchId) {
    return getDesktopCredentialURL(branchId);
}

export function getPackageBuildersURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/package-builders";
}

export function getPackageURL(companyId, branchId) {
    return getPackageBuildersURL(branchId);
}



export function getHeartBeatURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/heartbeat";
}

export function getHeartBeatByBranchURL(branchId) {
    return getHeartBeatURL(branchId);
}


export function getRolesURL() {
    return baseURL + "/roles/";
}

export function getDesktopOnlineStatusURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/desktop-online-status";
}

export function getBranchUsersURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/users";
}

export function getUsersByBranchURL(branchId) {
    return getBranchUsersURL(branchId);
}

export function getUsersByCompanyAndBranchURL(companyId, branchId) {
    return getBranchUsersURL(branchId);
}

export function syncAllMembersURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/customers/actions/sync-all";
}

export function getAllUsersURL() {
    return baseURL + "/users/";
}

function getAdminBranchStatsReportURL(branchId, reportName, month, year) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/" + reportName + "/month/" + month + "/year/" + year;
}

export function getMonthStatsURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "month-stats", month, year);
}

export function getChurnRateDataURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "churn-rate-data", month, year);
}

export function getTotalSalesDataURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "total-sales-data", month, year);
}

export function getTotalPosSalesURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "total-pos-sales", month, year);
}

export function getNewMembersStatsURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "new-members-stats", month, year);
}

export function getDayPassStatsURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "day-pass-stats", month, year);
}

export function getFrozenMemberStatsURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "frozen-member-stats", month, year);
}

export function getTrainerStatusURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "trainer-status", month, year);
}

export function getActiveMembersStatusURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "active-members-status", month, year);
}

export function getTotalActiveMembersStatusURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "total-active-members-status", month, year);
}

export function getMonthWiseSalesChartDataURL(branchId, month, year) {
    return getAdminBranchStatsReportURL(branchId, "month-wise-sales-chart-data", month, year);
}

export function activeMembersStatsURL() {
    return baseURL + "/activeMembersStats";
}

export function getCompanyURL(companyId) {
    return baseURL + "/companies/" + companyId;
}

const tecgymAdminRolesURL = baseURL + "/tecgymAdminRole";
const tecgymAdminUsersURL = baseURL + "/tecgymAdminUsers";
const tecgymAdminAuthURL = baseURL + "/admin";

export function getAnydeskURL(branchId) {
    return baseURL + "/admin/branches/" + branchId + "/anydesk";
}

export function getAllAnydeskURL(branchId) {
    return getAnydeskURL(branchId);
}

export function getAnydeskByBranchURL(branchId) {
    return getAnydeskURL(branchId);
}

export function saveAnydeskURL(branchId) {
    return getAnydeskURL(branchId);
}

export function getActZonesURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/act-zones";
}

export function getActZoneURL(branchId, zoneId) {
    return getActZonesURL(branchId) + "/" + encodeURIComponent(normalizePathId(zoneId));
}

export function getActZoneTerminalsURL(branchId, zoneId) {
    return getActZoneURL(branchId, zoneId) + "/terminals";
}

export function getActZoneTerminalURL(branchId, zoneId, terminalId) {
    return getActZoneTerminalsURL(branchId, zoneId) + "/" + encodeURIComponent(normalizePathId(terminalId));
}

export function updateAnydeskURL(branchId) {
    return getAnydeskURL(branchId);
}

export function deleteAnydeskURL(branchId) {
    return getAnydeskURL(branchId);
}

export function getOnboardingStatusURL(branchId) {
    return baseURL + "/admin/branches/" + branchId + "/onboarding-status";
}

export function getAllOnboardingStatusURL(branchId) {
    return getOnboardingStatusURL(branchId);
}

export function getOnboardingStatusByBranchURL(branchId) {
    return getOnboardingStatusURL(branchId);
}

export function saveOnboardingStatusURL(branchId) {
    return getOnboardingStatusURL(branchId);
}

export function updateOnboardingStatusURL(branchId) {
    return getOnboardingStatusURL(branchId);
}

export function updateTecgymAdminOnboardingStatusURL(branchId) {
    return updateOnboardingStatusURL(branchId);
}

export function getUpdateLicenseRequestURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/update-license-request";
}

export function getAllUpdateLicenseRequestsURL(branchId) {
    return getUpdateLicenseRequestURL(branchId);
}

export function getUpdateLicenseRequestsByBranchURL(branchId) {
    return getUpdateLicenseRequestURL(branchId);
}

export function saveUpdateLicenseRequestURL(branchId) {
    return getUpdateLicenseRequestURL(branchId);
}

export function addUpdateLicenseRequestURL(branchId) {
    return getUpdateLicenseRequestURL(branchId);
}

export function updateUpdateLicenseRequestURL(branchId) {
    return getUpdateLicenseRequestURL(branchId);
}

export function getUpdateLicenseRequestsURL(companyId, branchId) {
    return getUpdateLicenseRequestsByBranchURL(branchId);
}

export function getTecgymAdminRolesURL() {
    return tecgymAdminRolesURL;
}

export function createTecgymAdminRoleURL() {
    return tecgymAdminRolesURL;
}

export function updateTecgymAdminRoleURL(id) {
    return tecgymAdminRolesURL + "/" + encodeURIComponent(id);
}

export function deleteTecgymAdminRoleURL(id) {
    return tecgymAdminRolesURL + "/" + encodeURIComponent(id);
}

export function getTecgymAdminUsersURL() {
    return tecgymAdminUsersURL;
}

export function getTecgymAdminAuthenticateURL() {
    return tecgymAdminAuthURL + "/authenticate";
}

export function createTecgymAdminUserURL() {
    return tecgymAdminUsersURL;
}

export function updateTecgymAdminUserURL(id) {
    return tecgymAdminUsersURL + "/" + encodeURIComponent(id);
}

export function saveTecgymAdminUserAttendanceURL(id) {
    return tecgymAdminUsersURL + "/" + encodeURIComponent(id) + "/attendance";
}

export function deleteTecgymAdminUserURL(id) {
    return tecgymAdminUsersURL + "/" + encodeURIComponent(id);
}

const tecgymAdminAppActivitiesURL = baseURL + "/tecgymAdminAppActivity";

export function getAllTecgymAdminAppActivitiesURL() {
    return tecgymAdminAppActivitiesURL;
}

export function createTecgymAdminAppActivityURL() {
    return tecgymAdminAppActivitiesURL;
}

/** Admin proxy of TecFit subscription fee collection report (same data as reports/summary). */
export function getSubscriptionReportURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/subscription-report";
}

export function getSubscriptionReportByBranchURL(branchId) {
    return getSubscriptionReportURL(branchId);
}

export function getVisitorReportURL(branchId) {
    return baseURL + "/admin/branches/" + branchId + "/visitor-report";
}

export function getVisitorReportByBranchURL(branchId) {
    return getVisitorReportURL(branchId);
}

export function getSaleOrderReportURL(branchId) {
    return baseURL + "/admin/branches/" + branchId + "/sale-order-report";
}

export function getSaleOrderReportByBranchURL(branchId) {
    return getSaleOrderReportURL(branchId);
}

export function getActivityLogsURL(branchId) {
    const id = normalizePathId(branchId);
    return baseURL + "/admin/branches/" + encodeURIComponent(id) + "/activity-logs";
}

/** One query for Tecgym Admin and Tecfolk activity across all clients. */
export function getTecfolkActivityLogsURL() {
    return baseURL + "/admin/activity-logs";
}

const hardwareVendorsURL = baseURL + "/hardware-vendors";
const hardwareTechniciansURL = baseURL + "/hardware-technicians";

export function getHardwareVendorsURL() {
    return hardwareVendorsURL;
}

export function createHardwareVendorURL() {
    return hardwareVendorsURL;
}

export function updateHardwareVendorURL(id) {
    return hardwareVendorsURL + "/" + encodeURIComponent(id);
}

export function deleteHardwareVendorURL(id) {
    return updateHardwareVendorURL(id);
}

export function getHardwareTechniciansURL() {
    return hardwareTechniciansURL;
}

export function createHardwareTechnicianURL() {
    return hardwareTechniciansURL;
}

export function updateHardwareTechnicianURL(id) {
    return hardwareTechniciansURL + "/" + encodeURIComponent(id);
}

export function deleteHardwareTechnicianURL(id) {
    return updateHardwareTechnicianURL(id);
}